'use client';

import ParkBoundary from '@alltrails/maps/components/ParkBoundary/ParkBoundary';
import ParkResults from '@alltrails/maps/components/ParkResults/ParkResults';
import useMap from '@alltrails/maps/hooks/useMap';
import { getLayerBeforeId } from '@alltrails/maps/utils/layers';
import POIMapComponents from '@/components/POIMapComponents/POIMapComponents';
import TrailResultsMapComponents from '@/components/TrailResultsMapComponents/TrailResultsMapComponents';
import { useAppSelector } from '@/utils/redux';

export default function ExploreRootMapComponentsSlot() {
  const map = useMap();
  const { activePark } = useAppSelector(state => ({
    activePark: state.map.activePark
  }));
  const boundaryBeforeId = getLayerBeforeId(map, 'park-areas');

  return (
    <>
      <TrailResultsMapComponents />
      <ParkResults />
      {activePark && boundaryBeforeId !== undefined && activePark?.ID !== undefined && (
        <ParkBoundary hoveredId={String(activePark.ID)} beforeId={boundaryBeforeId} id={activePark.ID || 0} />
      )}
      <POIMapComponents poiLocation="explore map default state" shouldNavigateToPOIUrl />
    </>
  );
}
